export interface DisplayFormatOptions {
    label?: string;
    translationKey?: string;
    type?: 'string' | 'number' | 'date' | 'boolean';
    format?: string; // e.g. 'yyyy/MM/dd'
  }
  
  const formatMetadataKey = Symbol('DisplayFormat');
  
  export function DisplayFormat(options: DisplayFormatOptions): PropertyDecorator {
    return (target, propertyKey) => {
      const existingMetadata = Reflect.getMetadata(formatMetadataKey, target) || {};
      existingMetadata[propertyKey as string] = options;
      Reflect.defineMetadata(formatMetadataKey, existingMetadata, target);
    };
  }
  
  export function getDisplayFormats(target: any): Record<string, DisplayFormatOptions> {
    return Reflect.getMetadata(formatMetadataKey, target) || {};
  }
  